// Reading process.env is an expensive operation so do it once on load and store it in memory for later use
const loginAddress = process.env.REACT_APP_BASE_LOGIN_ADDRESS;
const apiUrl = process.env.REACT_APP_BASE_API;
const bffUrl = process.env.REACT_APP_BFF_API;
const googleMapsAPIKey = process.env.GOOGLE_MAPS_API_KEY;

const getIdUiUrl = () => loginAddress;

export enum BaseTypes {
    DIRECT = 'direct',
    BFF = 'bff',
}
const getAPIUrl = (baseType: BaseTypes) => {
    return baseType === BaseTypes.DIRECT ? apiUrl : bffUrl;
};

const getGoogleMapsAPIKey = () => googleMapsAPIKey;

export { getIdUiUrl, getAPIUrl, getGoogleMapsAPIKey };
